import { useState, useEffect, useContext } from "react";
import VideoThumbnail from "@std/legacy_componentry/Thumbnails/Thumbnail";
import LoadingThumbnail from "@std/legacy_componentry/Thumbnails/LoadingThumbnail";
import InfiniteScroll from "react-infinite-scroll-component";
import ClientSort from "@std/legacy_componentry/Videos/Sort/ClientSort";
import TeamSort from "@std/legacy_componentry/Videos/Sort/TeamSort";
import FavouriteSort from "@std/legacy_componentry/Videos/Sort/FavouriteSort";
import TypeSort from "@std/legacy_componentry/Videos/Sort/TypeSort";
import FeedSort from "@std/legacy_componentry/Videos/Sort/FeedSort";
import { PagewideContext } from "@std/legacy_componentry/Root/Shared/PagewideContext.jsx";
import { server } from "@std/lib/publicEnv";
import { fetchClients } from "@std/lib/helpers";
import Image from "next/image";
import { FaArrowLeft, FaFilter } from "react-icons/fa";
import { useRouter } from "next/router";

const defaultFilters = {
  client: null,
  editor: null,
  favourite: false,
  sort: "chronological-descend",
};

const defaultSortMap = {
  "chronological-descend": "",
  "chronological-ascend": "&sort=reverse",
  "most-viewed": "&sort=views-highest",
};

const userMetaDefault = {
  id: null,
  name: null,
  avatar: null,
  editor: false,
  active: false,
};

export default function Videos() {
  const router = useRouter();
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [videos, setVideos] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [more, setMore] = useState(true);
  const [videoType, setVideoType] = useState("unsorted");
  const [totalSearchResults, setTotalSearchResults] = useState(0);
  const [filters, setFilters] = useState(defaultFilters);
  const [videoTypeLoading, setVideoTypeLoading] = useState(false);
  const [userMeta, setUserMeta] = useState(userMetaDefault);
  const { pageContext, setPageContext } = useContext(PagewideContext);

  const sortExpression = {
    route:
      videoType == "videos"
        ? "getVideos"
        : videoType == "shorts"
        ? "getShorts"
        : "getUnsorted",
    name:
      videoType == "videos"
        ? "Videos"
        : videoType == "shorts"
        ? "Shorts"
        : "Videos & shorts",
  };

  const filtersChanged =
    filters.editor !== defaultFilters.editor ||
    filters.client !== defaultFilters.client ||
    filters.favourite !== defaultFilters.favourite ||
    videoType !== "unsorted";
  const sortStr = `${
    filters.editor !== null ? `&editorSort=${filters.editor}` : ""
  }${filters.favourite == true ? "&thumbnailFavourites=true" : ""}${
    filters.client !== null ? `&clientIds=${filters.client}` : ""
  }${defaultSortMap[filters.sort || "chronological-descend"]}`;

  async function fetchVideos(initial) {
    if (initial && videos.length !== 0) return;
    const res = await fetch(
      `${server}/api/${sortExpression.route}?start=${videos.length}&limit=${
        initial ? 40 : 20
      }&thumbnailVideosOnly=true${sortStr}`
    )
      .then((res) => res.json())
      .catch((err) => console.log(err));
    let videoArr = res.data;
    if (res.remaining <= 0) setMore(false);
    else setMore(true);

    let shownVideos = [];
    setVideos((video) =>
      [...video, ...videoArr].filter((v) => {
        if (shownVideos.includes(v.id)) return false;
        shownVideos.push(v.id);
        return true;
      })
    );
  }

  useEffect(() => {
    async function getClients() {
      const request = await fetchClients({
        context: { state: pageContext, setState: setPageContext, loading },
        thumbnails: true,
      });
      setClients(request);
      setLoading(false);
    }

    async function fetchInitialVideos(initial, vtl) {
      if (initial && videos.length !== 0) return;
      if (vtl) {
        setTotalSearchResults(0);
        setVideoTypeLoading(true);
        setLoading(true);
      }
      const res = await fetch(
        `${server}/api/${sortExpression.route}?start=${videos.length}&limit=${
          initial ? 40 : 20
        }&thumbnailVideosOnly=true${sortStr}`
      )
        .then((res) => res.json())
        .catch((err) => console.log(err));
      if (initial && res.data.length >= 40)
        setTotalSearchResults(res.remaining + 40);
      if (initial && res.data.length < 40)
        setTotalSearchResults(res.data.length);
      let videoArr = res.data;
      if (res.remaining <= 0) setMore(false);
      else setMore(true);

      let shownVideos = [];
      setVideos((video) =>
        [...video, ...videoArr].filter((v) => {
          if (shownVideos.includes(v.id)) return false;
          shownVideos.push(v.id);
          return true;
          // check if last video
        })
      );

      if (vtl) {
        setVideoTypeLoading(false);
      }
    }

    if (router.isReady && loading && !videoTypeLoading) {
      if (router.query.favourite == "true") {
        setFilters({ ...filters, favourite: true });
        router.replace("/v", undefined, { shallow: true });
      }
      getClients();
      fetchInitialVideos(true, false);
    }

    if (!loading && videoTypeLoading) {
      setVideos([]);
      fetchInitialVideos(true, true);
    }
  }, [
    router.isReady,
    router.query.q,
    videos.length,
    clients.length,
    loading,
    videoTypeLoading,
  ]);

  const filterDiv = (
    <>
      <div className="flex flex-row gap-x-4 gap-y-4 items-center">
        <FavouriteSort
          onClick={() => {
            if (videoTypeLoading) return;
            setFilters({
              ...filters,
              favourite: !filters.favourite,
            });
            setVideoTypeLoading(true);
          }}
          current={filters.favourite}
        />
        {false && (
          <TypeSort
            onClick={(c) => {
              if (videoTypeLoading) return;
              setVideoType(c);
              setVideoTypeLoading(true);
            }}
            current={videoType}
          />
        )}
      </div>
      <div className="flex flex-row gap-x-4 gap-y-4 items-center">
        <ClientSort
          clients={clients}
          includeAll
          onClick={(o) => {
            if (videoTypeLoading) return;
            if (o == null) {
              setFilters({
                ...filters,
                client: null,
              });
              if (userMeta.active && filters.editor) {
                setUserMeta({
                  active: true,
                  name: filters.editor == "solo" ? "Kooleyy" : "Continuity",
                  avatar:
                    filters.editor == "solo"
                      ? "/kooleyy.png"
                      : "/continuity.png",
                  editor: true,
                });
              } else {
                setUserMeta(userMetaDefault);
              }
              setVideoTypeLoading(true);
              return;
            } else {
              const clientUser = clients.find((c) => c.id == o);
              setFilters({
                ...filters,
                client: o || null,
              });
              setUserMeta({
                active: true,
                name: clientUser.name,
                avatar: clientUser.thumbnail.default.url,
                editor: false,
              });
            }
            setVideoTypeLoading(true);
          }}
          current={filters.client}
        />
        <TeamSort
          onClick={(o) => {
            if (videoTypeLoading) return;
            switch (o) {
              case "team":
                if (userMeta.active && !userMeta.editor) break;
                setUserMeta({
                  active: true,
                  name: "Continuity",
                  avatar: "/continuity.png",
                  editor: true,
                });
                break;

              case "solo":
                if (userMeta.active && !userMeta.editor) break;
                setUserMeta({
                  active: true,
                  name: "Kooleyy",
                  avatar: "/kooleyy.png",
                  editor: true,
                });
                break;

              default:
                if (userMeta.active && !userMeta.editor) break;
                setUserMeta(userMetaDefault);
                break;
            }
            setFilters({
              ...filters,
              editor: o || null,
            });
            setVideoTypeLoading(true);
          }}
          current={filters.editor}
        />
      </div>
    </>
  );

  return (
    <main className="flex flex-col gap-y-4 px-12 py-4 pt-8 md:py-12 text-white font-BreezeHeader font-bold sm:items-start min-h-screen">
      <div className="flex flex-row justify-between w-full gap-y-4 items-center">
        <div className="flex flex-col gap-y-4 items-start">
          <div className="md:flex md:flex-row items-center gap-x-4">
            <div
              className={`flex flex-row gap-x-2 mb-2 ${
                !filtersChanged && "md:hidden"
              }`}
            >
              {filtersChanged && (
                <button
                  className="w-fit flex flex-row gap-x-2 mb-4 md:mb-0 text-xs leading-tight px-4 py-2 items-center bg-cyan-200 hover:bg-cyan-300 active:shadow-lg transition duration-150 ease-in-out uppercase text-sp text-black rounded-full"
                  onClick={() => {
                    setFilters(defaultFilters);
                    setUserMeta(userMetaDefault);
                    setVideoType("unsorted");
                    setVideoTypeLoading(true);
                  }}
                >
                  <FaArrowLeft />
                  Back
                </button>
              )}
              <FeedSort
                current={filters.sort}
                onClick={(s) => {
                  if (videoTypeLoading) return;
                  setFilters({
                    ...filters,
                    sort: s || "chronological-descend",
                  });
                  setVideoTypeLoading(true);
                }}
                hiddenResponsive
              />
            </div>
            {!userMeta.active && (
              <>
                <div className="flex flex-col gap-y-1 md:flex-row md:gap-y-0 md:gap-x-4 md:items-center">
                  <div className="flex flex-row gap-x-4 items-center text-2xl font-BreezeAltHeader">
                    All {filters.favourite == true && "featured"} thumbnails{" "}
                    {/*<>({sortExpression.name.toLowerCase()})</>*/}
                    <button
                      className="md:hidden"
                      onClick={() => setFiltersOpen(!filtersOpen)}
                    >
                      <FaFilter className="text-xl hover:text-gray-300 transition duration-150 ease-in-out" />
                    </button>
                  </div>
                  <span className="text-base font-BreezeButton font-semibold text-gray-300">
                    {videoTypeLoading
                      ? `Loading..`
                      : totalSearchResults === 0
                      ? `No results found`
                      : `Showing ${videos.length} of ${totalSearchResults} results`}
                  </span>
                </div>
              </>
            )}
            {userMeta.active && (
              <>
                <div className="flex flex-col gap-y-2 md:flex-row md:gap-y-0 md:gap-x-4 md:items-center">
                  <div className="flex flex-row gap-x-4 sm:gap-x-2 items-center md:flex-row">
                    <img
                      referrerPolicy="no-referrer"
                      className="rounded-xl w-12 md:w-8"
                      alt={"Continuity"}
                      src={userMeta.avatar}
                    />
                    <div className="flex flex-col md:flex-row md:gap-x-2">
                      <h1 className="text-2xl font-medium font-BreezeAltHeader">
                        {
                          // userMeta.editor ? <>{filters.favourite ? "Featured" : "" } thumbnails ({sortExpression.name} edited by <b>{userMeta.name}</b>)</> : <><b>{userMeta.name}</b>&apos;s {filters.favourite ? "favourited" : "" } thumbnails ({sortExpression.name.toLowerCase()}{ filters.editor ? <> edited by <b>{filters.editor === "solo" ? "Kooleyy" : "Continuity"}</b></> : ""  })</>
                          userMeta.editor ? (
                            <>
                              {filters.favourite ? "Featured" : ""} thumbnails
                            </>
                          ) : (
                            <>
                              <b>{userMeta.name}</b>&apos;s{" "}
                              {filters.favourite ? "featured" : ""} thumbnails
                            </>
                          )
                        }
                      </h1>
                    </div>
                    <button
                      className="md:hidden"
                      onClick={() => setFiltersOpen(!filtersOpen)}
                    >
                      <FaFilter className="text-xl hover:text-gray-300 transition duration-150 ease-in-out" />
                    </button>
                  </div>
                  <span className="text-base font-BreezeButton font-semibold text-gray-300">
                    {videoTypeLoading
                      ? `Loading..`
                      : totalSearchResults === 0
                      ? `No results found`
                      : `Showing ${videos.length} of ${totalSearchResults} results`}
                  </span>
                </div>
              </>
            )}
          </div>
          <div
            className={`hidden md:flex flex-col items-end md:flex-row gap-x-4 gap-y-4`}
          >
            {filterDiv}
          </div>
        </div>
        <div className="hidden md:block">
          <FeedSort
            current={filters.sort}
            onClick={(s) => {
              if (videoTypeLoading) return;
              setFilters({
                ...filters,
                sort: s || "chronological-descend",
              });
              setVideoTypeLoading(true);
            }}
          />
        </div>
      </div>
      <div
        className={`${
          filtersOpen ? "flex" : "hidden"
        } z-[40] md:hidden flex-col md:flex-row gap-x-4 gap-y-4`}
      >
        {filterDiv}
      </div>
      {(() => {
        if (loading) {
          const k = [...Array(40).keys()];
          return (
            <>
              <div className="grid sm:grid-cols-3 md:grid-cols-4 gap-x-4 gap-y-8 overflow-x-hidden no-scrollbar py-2 pt-4 px-4">
                {k.map((i) => (
                  <LoadingThumbnail key={i} />
                ))}
              </div>
            </>
          );
        } else {
          const k = [...Array(15).keys()];
          return (
            <>
              <InfiniteScroll
                className="grid sm:grid-cols-3 md:grid-cols-4 gap-x-4 gap-y-8 overflow-x-hidden no-scrollbar py-2 pt-4 px-4"
                dataLength={videos.length}
                next={fetchVideos}
                hasMore={more}
                loader={k.map((i) => (
                  <LoadingThumbnail key={i} />
                ))}
              >
                {videos.map((video, index) => {
                  if (video === null) return;
                  return (
                    <VideoThumbnail
                      id={video?.id}
                      timestamp={new Date(video.timestamp)}
                      key={index}
                      href={`https://youtube.com/watch?v=${video.id}`}
                      thumb={`https://i3.ytimg.com/vi_webp/${video.id}/maxresdefault.webp`}
                      title={video.title}
                      author={video.channel.name}
                      authorPhoto={
                        clients.find((c) => c.id === video.channel.id)
                          ?.thumbnail?.high?.url
                      }
                      authorHref={`https://youtube.com/channel/${video.channel.id}`}
                      views={video.social.views}
                      authorId={video.channel.id}
                    />
                  );
                })}
              </InfiniteScroll>
              {!more && (
                <div className="flex flex-col justify-center items-center w-full py-8 gap-y-4">
                  <Image
                    width="128"
                    height="128"
                    referrerPolicy="no-referrer"
                    className=" w-32 h-32"
                    alt={"Cookie Munch"}
                    src={"/cookieEat.gif"}
                  />
                  <h1 className="text-xl font-BreezeButton text-center">
                    This is the end of the timeline
                  </h1>
                </div>
              )}
            </>
          );
        }
      })()}
    </main>
  );
}
